import { Link } from "react-router-dom";
import {
  LoginIcon,
  UserAddIcon,
  LightBulbIcon,
} from "@heroicons/react/outline";

const PublicNavbar = () => {
  return (
<>
    <div className="mx-auto px-4 py-3 sm:px-6 lg:px-8 bg-gray-800">
      <div className="flex justify-between h-16">
        <div className="flex items-center">
          <div className="flex-shrink-0 flex items-center">
          <Link
              to="/"
              type="button"
            >
            <LightBulbIcon className="h-10 w-10 text-yellow-200" />
            </Link>
            <p className="font-bold text-xl lg:font-bold lg:text-4xl ml-3 text-yellow-200">STOMAREAS</p>
          </div>
        
        </div>
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <Link
              to="/login"
              type="button"
              className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500"
            >
              <LoginIcon
                className="-ml-1 lg:mr-2 h-5 w-5"
                aria-hidden="true"
              />
              <span className="hidden lg:block">Login</span>
            </Link>
          </div>
          <div className="ml-3 md:ml-4 md:flex-shrink-0 md:flex md:items-center">
            <Link
              to="/register"
              className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-pink-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500"
            >
              <UserAddIcon
                className="-ml-1 lg:mr-2 h-5 w-5"
                aria-hidden="true"
              />
              <span className="hidden lg:block">Register</span>
            </Link>
          </div>
        </div>
      </div>
    </div>

  </>
  );
};

export default PublicNavbar;
